import { useMutation } from '@tanstack/react-query';

import { resubmitEvent } from '../../services/promoterEndpoint.ts';
import { tanstackQueryClient } from '../../services/tanstackQueryClient.ts';

/** Puts a declined event back in review. Saving the changes is a separate update before this. */
export const useEventResubmitMutation = () =>
  useMutation({
    mutationFn: async (eventId: string) => {
      const result = await resubmitEvent(eventId);

      if ('type' in result) {
        throw new Error(result.message);
      }

      return result;
    },
    // The event moves from one dashboard tab to another, so every event list and count is stale.
    onSuccess: () => tanstackQueryClient.invalidateQueries({ queryKey: ['events'] }),
  });
